import React, { Component } from "react";
import { Button } from "reactstrap";
import style from "./GeneralSetting.module.css";
import Dropdown from "../../utils/Dropdown.json";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import api from "../../utils/Api";
import { connect } from "react-redux";
import { fetchDropdownList } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";

export class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      max_upload: "",
      max_product_image_upload: "",
      vat_percent: "",
      max_paymentproof_upload: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      isDataFetching: false,
      isScreenLoaded: false,
    };
  }

  componentDidMount() {
    document.title = 'General Settings - TechToMedix';
    // Calling fetch picklist options method
    this.getGeneralSetting();
    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 2000);
  }

  // fetching general setting options
  getGeneralSetting = async () => {
    this.setState({
      isDataFetching: true,
    });
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get("setting/fetch", {
        headers: headers,
      });
      //console.log("Getting response data for general setting - ", response);

      this.setState(
        {
          max_upload: response.data.data.setting.max_upload,
          max_product_image_upload:
            response.data.data.setting.max_product_image_upload,
          vat_percent: response.data.data.setting.vat_percent,
          max_paymentproof_upload:
            response.data.data.setting.max_paymentproof_upload,
        },
        () => {
          this.setState({
            isDataFetching: false,
          });

          // Save settings data in locale storage
          const settings = {
            max_upload: response.data.data.setting.max_upload,
            max_product_image_upload:
              response.data.data.setting.max_product_image_upload,
            vat_percent: response.data.data.setting.vat_percent,
            max_paymentproof_upload:
              response.data.data.setting.max_paymentproof_upload,
          };
          localStorage.setItem("SETTING_INFO", JSON.stringify(settings));
        }
      );
    } catch (error) {
      console.log("Error", error);
      this.setState({
        isDataFetching: false,
      });
    }
  };

  // common form input handling
  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
  };

  render() {
    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <div className={style.settingMainWrapper}>
        <div className="row">
          <div className="col-md-12">
            <h3>General Settings</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
              These are the general system wide settings. You can change as
              needed.
            </p>
          </div>
        </div>
        <Formik
          initialValues={this.state}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            max_upload: Yup.string()
              .required("This field is required")
              .matches(/^[0-9]*$/, "Only numbers allowed"),
         //     .matches(/^[0-5]$/, "only 5 uploads are allowed"),
            max_product_image_upload: Yup.string()
              .required("This field is required")
              .matches(/^[0-9]*$/, "Only numbers allowed")
              .matches(/^[0-5]$/, "only 5 uploads are allowed"),
            vat_percent: Yup.string()
              .required("This field is required")
              .matches(/^[0-9]*$/, "Only numbers allowed"),
             // .matches(/^[1-9][0-9]*$/, "VAT percent should be greater than 0"),
            max_paymentproof_upload: Yup.string()
              .required("This field is required")
              .matches(/^[0-9]*$/, "Only numbers allowed")
              .matches(/^[0-5]$/, "only 5 uploads are allowed"),
          })}
          onSubmit={async (data) => {
            // alert("SUCCESS!! :-)\n\n" + JSON.stringify(fields, null, 4));
            this.setState({
              isLoading: true,
            });
            // Payload to be sent
            const payload = {
              max_upload: data.max_upload,
              max_product_image_upload: data.max_product_image_upload,
              vat_percent: data.vat_percent,
              max_paymentproof_upload: data.max_paymentproof_upload,
            };
            // Headers
            const headers = {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
            };
            try {
              const response = await api.post("setting/general/save", payload, {
                headers: headers,
              });
              if (response.status === 200) {
                // Save settings data in locale storage  
                  setTimeout(() => {
                    this.getGeneralSetting();
                  }, 2000);
                this.setState({
                  isLoading: false,
                  successMessage: "Setting saved successfully!",
                });
                if (this.state.isEditMode) {
                  this.setState({
                    isLoading: false,
                    successMessage: "Error!",
                  });
                }
              }
              setTimeout(() => {
                this.setState({
                  successMessage: "",
                });
              }, 2000);
            } catch (error) {
              if (error.response) {
                this.setState({
                  isLoading: false,
                  errorMessage: "Internal server error occured",
                });
                setTimeout(() => {
                  this.setState({
                    errorMessage: "",
                  });
                }, 2000);
              }
              console.log("Error in save general setting", error);
            }
          }}
          render={({ errors, status, touched }) => (
            <Form>
              <div className="form-box-shadow">
                <div className="row">
                  <div className="col-md-12">
                    <h4>Upload Settings</h4>
                  </div>
                </div>
                {this.state.isDataFetching ? (
                  <div className={style.loadingWrapper}>
                    <img src={ttmLoader} alt="loader" className={style.loading} />
                  </div>
                ) : (
                  <div>
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-xl-4">
                        <label htmlFor="max_upload">
                          Maximum document Upload Allowed for contacts:
                        </label>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xl-1">
                        <div className="form-group">
                          <Field
                            type="text"
                            id="max_upload"
                            name="max_upload"
                            maxLength="2"
                            value={this.state.max_upload}
                            onChange={this.handleInputChange}
                            className={
                              "form-control" +
                              (errors.max_upload && touched.max_upload
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="max_upload"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-xl-4">
                        <label htmlFor="max_product_image_upload">
                          Maximum product images upload allowed :
                        </label>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xl-1">
                        <div className="form-group">
                          <Field
                            type="text"
                            maxLength="1"
                            id="max_product_image_upload"
                            name="max_product_image_upload"
                            value={this.state.max_product_image_upload}
                            onChange={this.handleInputChange}
                            className={
                              "form-control" +
                              (errors.max_product_image_upload &&
                              touched.max_product_image_upload
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="max_product_image_upload"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-xl-4">
                        <label htmlFor="vat_percent">
                          Vat % for invoices :
                        </label>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xl-1">
                        <div className="form-group">
                          <Field
                            type="text"
                            id="vat_percent"
                            name="vat_percent"
                            value={this.state.vat_percent}
                            onChange={this.handleInputChange}
                            className={
                              "form-control" +
                              (errors.vat_percent && touched.vat_percent
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="vat_percent"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-xl-4">
                        <label htmlFor="max_paymentproof_upload">
                          Maximum proof of payments upload allowed
                        </label>
                      </div>
                      <div className="col-md-3 col-lg-3 col-xl-1">
                        <div className="form-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="max_paymentproof_upload"
                            name="max_paymentproof_upload"
                            maxLength="1"
                            value={this.state.max_paymentproof_upload}
                            onChange={this.handleInputChange}
                            className={
                              "form-control" +
                              (errors.max_paymentproof_upload &&
                              touched.max_paymentproof_upload
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="max_paymentproof_upload"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-12">
                  {this.state.isLoading ? (
                    <div className={style.loadingWrapper}>
                      <img src={ttmLoader} className={style.loading} />
                    </div>
                  ) : (
                    <div>
                      {this.state.successMessage && (
                        <p className={style.successMessage}>
                          {this.state.successMessage}
                        </p>
                      )}
                      {this.state.errorMessage && (
                        <p className={style.errorMessage}>
                          {this.state.errorMessage}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className={`row ${style.settingBtnWrapper}`}>
                <div
                  className={`col-md-12 d-flex justify-content-center justify-content-sm-end ${style.btnWrapper}`}
                >
                  <Button type="submit" color="primary">
                    Save
                  </Button>
                </div>
              </div>
            </Form>
          )}
        />
        {/* <form>
          <div className="form-box-shadow">
            <div className="row">
              <div className="col-md-12">
                <h4>Upload Settings</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-4">
                <label htmlFor="maximum_upload">
                  Maximum document Upload Allowed for contacts:
                </label>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-1">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="maximum_upload"
                    name="maximum_upload"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-4">
                <label htmlFor="maximum_upload">
                  Maximum product images upload allowed :
                </label>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-1">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="maximum_image_upload"
                    name="maximum_image_upload"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-4">
                <label htmlFor="maximum_upload">Vat % for invoices :</label>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-1">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="maximum_image_upload"
                    name="maximum_image_upload"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-4">
                <label htmlFor="maximum_upload">
                  Maximum proof of payments upload allowed
                </label>
              </div>
              <div className="col-md-3 col-lg-3 col-xl-1">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="maximum_image_upload"
                    name="maximum_image_upload"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={`row ${style.settingBtnWrapper}`}>
            <div
              className={`col-md-12 d-flex justify-content-center justify-content-sm-end ${style.btnWrapper}`}
            >
              <Button type="button" color="primary">
                Save
              </Button>
            </div>
          </div>
        </form> */}
      </div>
    );
  }
}

// export default Setting;

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Setting);
